// ViewCards - the technical documentation index (guide 18.1): every stored
// view as a card with its title, systems, filters, source documents,
// version, date and status, and a New view button.
import React from "react";
import { Button, Empty, Tag } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { STATUS_LABEL } from "./viewModel";
import { ViewThumbnail } from "./ViewPdfActions";   // root-f5's render of the view itself
import Contained from "./Contained";

const filterText = (f) => Object.entries(f || {}).map(([k, v]) => `${k} ${Array.isArray(v) ? v.join("-") : v}`).join(", ");

export default function ViewCards({ projectId, data, manifest, onOpen, onNew }) {
  const views = (data && data.views) || [];
  const systemLabel = (id) => (((manifest && manifest.systems) || []).find((s) => s.id === id) || {}).label || id;
  return (
    <section>
      <div className="g-viewhead">
        <div>
          <h2>Technical documentation</h2>
          <p className="g-note">
            Views of one system or scope, generated from the project's drawings on request: an isometric and a schedule, stored as versions.
            Each view also opens as its own tab.
          </p>
        </div>
        {data && data.canAdd && <Button type="primary" icon={<PlusOutlined />} onClick={onNew}>New view</Button>}
      </div>
      {!views.length ? (
        <Empty description={data && data.canAdd ? "No views yet. Use New view to document a category." : "No views have been published for this project yet."} />
      ) : (
        <div className="g-cards g-viewcards">
          {views.map((v) => (
            <button key={v.viewId} type="button" onClick={() => onOpen(v.viewId)}>
              {projectId && <Contained name="thumbnail"><ViewThumbnail projectId={projectId} viewId={v.viewId} width={240} /></Contained>}
              <b>{v.title}</b>
              <span>
                <Tag color={v.status === "published" ? "green" : v.status === "in_review" ? "orange" : "default"}>{STATUS_LABEL[v.status]}</Tag>
                {v.stale && <Tag color="red">Stale</Tag>}
                Version {v.version}, {String(v.updatedAt).slice(0, 10)}
              </span>
              <span>{(v.summary && v.summary.runs) || 0} runs, {((v.summary && v.summary.knownLengthFt) || 0).toLocaleString()} ft known</span>
              {v.systems.length > 0 && <span>Systems: {v.systems.map(systemLabel).join(", ")}</span>}
              {filterText(v.filter) && <span>Filter: {filterText(v.filter)}</span>}
              {v.documents.length > 0 && <span>From: {v.documents.join("; ")}</span>}
            </button>
          ))}
        </div>
      )}
    </section>
  );
}
